import { FC } from "react";

const TIMEOUT_MESSAGE = "Error: Timeout. Please try again.";

/** Static timeout error message rendered after the request has been cancelled due to timeout. */
export const TimeoutErrorMessage: FC = () => (
  <div className="al-mt-2 al-px-4">
    <span className="al-italic al-text-sm al-text-red-600" role="alert">
      {TIMEOUT_MESSAGE}
    </span>
  </div>
);
